<section>
  @if (label()) {
    <h4>{{ label() }}</h4>
  }
  <div class="container">
    @if (units().includes('weeks')) {
      <div class="unit">
        <span>weeks:</span>
        <vectronic-formly-time-input-box
          [maxValue]="maxWeeks()"
          [minValue]="minWeeks()"
          [control]="getFormControl('weeks')"
          [maxNumberOfDigits]="3"
        ></vectronic-formly-time-input-box>
      </div>
    }
    @if (units().includes('days')) {
      <div class="unit">
        <span>days:</span>
        <vectronic-formly-time-input-box
          [maxValue]="maxDays()"
          [minValue]="minDays()"
          [control]="getFormControl('days')"
        ></vectronic-formly-time-input-box>
      </div>
    }
    @if (units().includes('hours')) {
      <div class="unit">
        <span>hours:</span>
        <vectronic-formly-time-input-box
          [maxValue]="maxHours()"
          [minValue]="minHours()"
          [control]="getFormControl('hours')"
        ></vectronic-formly-time-input-box>
      </div>
    }
    @if (units().includes('minutes')) {
      <div class="unit">
        <span>minutes:</span>
        <vectronic-formly-time-input-box
          [maxValue]="maxMinutes()"
          [minValue]="minMinutes()"
          [control]="getFormControl('minutes')"
        ></vectronic-formly-time-input-box>
      </div>
    }
  </div>
  @if (maxDurationHumanReadable()) {
    <legend>max: {{ maxDurationHumanReadable() }}</legend>
  }
</section>
